export enum BenefitEndpoints {
  FetchBenefits = '/benefits',
}
